function favTogglePlay(e) {
  e.classList.contains("active")
    ? (e.classList.remove("active"), e.pause())
    : (e.classList.add("active"), e.play());
}
var oldScrollY = window.scrollY;
function scrollingClass(e) {
  var t = window.pageYOffset || document.documentElement.scrollTop;
  (0 === t
    ? (document.body.classList.remove("scrolling"),
      document.body.classList.remove("scrolling-up"),
      document.body.classList.remove("scrolling-down"),
      "initially" == document.body.dataset.invertedHeader &&
        document.body.classList.add("inverted-header"))
    : (document.body.classList.add("scrolling"),
      "initially" == document.body.dataset.invertedHeader &&
        document.body.classList.remove("inverted-header")),
    oldScrollY < t
      ? (document.body.classList.add("scrolling-down"),
        document.body.classList.remove("scrolling-up"))
      : (document.body.classList.add("scrolling-up"),
        document.body.classList.remove("scrolling-down")),
    (oldScrollY = t),
    document.querySelector("header.header") &&
      document.documentElement.style.setProperty(
        "--header-scroll-offset",
        parseInt(
          document.querySelector("header.header").getBoundingClientRect().top,
        ) + "px",
      ));
}
if (
  (window.addEventListener("scroll", scrollingClass),
  scrollingClass(),
  document.body.querySelector('[data-inverted-header="first-section"]'))
) {
  let i = document.body.querySelector('[data-inverted-header="first-section"]')
      .dataset.invertedHeaderThreshold,
    e = document.querySelector("#MainContent > .shopify-section:first-of-type"),
    t = new IntersectionObserver(
      (e, t) => {
        e.forEach((e) => {
          e.intersectionRatio > i
            ? document.body.classList.add("inverted-header")
            : document.body.classList.remove("inverted-header");
        });
      },
      { threshold: i },
    );
  e && t.observe(e);
}
function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
  (e.setAttribute("role", "button"),
    e.setAttribute("aria-expanded", e.parentNode.hasAttribute("open")),
    e.nextElementSibling.getAttribute("id") &&
      e.setAttribute("aria-controls", e.nextElementSibling.id),
    e.addEventListener("click", (e) => {
      e.currentTarget.setAttribute(
        "aria-expanded",
        !e.currentTarget.closest("details").hasAttribute("open"),
      );
    }),
    e.closest("header-drawer, menu-drawer") ||
      e.parentElement.addEventListener("keyup", onKeyUpEscape));
});
let trapFocusHandlers = {};
function trapFocus(t, e = t) {
  var i = getFocusableElements(t),
    s = i[0],
    n = i[i.length - 1];
  (removeTrapFocus(),
    (trapFocusHandlers.focusin = (e) => {
      (e.target !== t && e.target !== n && e.target !== s) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (e) {
      "TAB" === e.code.toUpperCase() &&
        (e.target !== n || e.shiftKey || (e.preventDefault(), s.focus()),
        e.target === t || e.target === s) &&
        e.shiftKey &&
        (e.preventDefault(), n.focus());
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    e.focus(),
    "INPUT" === e.tagName &&
      ["search", "text", "email", "url"].includes(e.type) &&
      e.value &&
      e.setSelectionRange(0, e.value.length));
}
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  let t = [
      "ARROWUP",
      "ARROWDOWN",
      "ARROWLEFT",
      "ARROWRIGHT",
      "TAB",
      "ENTER",
      "SPACE",
      "ESCAPE",
      "HOME",
      "END",
      "PAGEUP",
      "PAGEDOWN",
    ],
    e = null,
    i = null;
  (window.addEventListener("keydown", (e) => {
    t.includes(e.code.toUpperCase()) && (i = !1);
  }),
    window.addEventListener("mousedown", (e) => {
      i = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        (e && e.classList.remove("focused"),
          i || (e = document.activeElement).classList.add("focused"));
      },
      !0,
    ));
}
function pauseAllMedia() {
  (document.querySelectorAll(".js-youtube").forEach((e) => {
    e.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*",
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document.querySelectorAll("video").forEach((e) => e.pause()),
    document.querySelectorAll("product-model").forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    }));
}
function removeTrapFocus(e = null) {
  (document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    e && e.focus());
}
function onKeyUpEscape(e) {
  var t;
  "ESCAPE" === e.code.toUpperCase() &&
    (e = e.target.closest("details[open]")) &&
    ((t = e.querySelector("summary")),
    e.removeAttribute("open"),
    t.setAttribute("aria-expanded", !1),
    t.focus());
}
class HTMLUpdateUtility {
  static viewTransition(e, t, i = [], s = []) {
    i?.forEach((e) => e(t));
    i = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(i, t.outerHTML);
    let n = i.firstChild,
      o = Date.now();
    (e.querySelectorAll("[id], [form]").forEach((e) => {
      (e.id && (e.id = e.id + "-" + o),
        e.form && e.setAttribute("form", e.form.getAttribute("id") + "-" + o));
    }),
      e.parentNode.insertBefore(n, e),
      (e.style.display = "none"),
      s?.forEach((e) => e(n)),
      setTimeout(() => e.remove(), 500));
  }
  static setInnerHTML(e, t) {
    ((e.innerHTML = t),
      e.querySelectorAll("script").forEach((e) => {
        let t = document.createElement("script");
        (Array.from(e.attributes).forEach((e) => {
          t.setAttribute(e.name, e.value);
        }),
          t.appendChild(document.createTextNode(e.innerHTML)),
          e.parentNode.replaceChild(t, e));
      }));
  }
}
class QuantityInput extends HTMLElement {
  constructor() {
    (super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.input.addEventListener("change", this.onInputChange.bind(this)),
      this.querySelectorAll("button").forEach((e) =>
        e.addEventListener("click", this.onButtonClick.bind(this)),
      ));
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    (this.validateQtyRules(),
      (this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this),
      )));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(e) {
    this.validateQtyRules();
  }
  onButtonClick(e) {
    e.preventDefault();
    var t = this.input.value;
    ("plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent));
  }
  validateQtyRules() {
    var e,
      t = parseInt(this.input.value);
    (this.input.min &&
      ((e = parseInt(this.input.min)),
      this.querySelector(".quantity__button[name='minus']").classList.toggle(
        "disabled",
        t <= e,
      )),
      this.input.max &&
        ((e = parseInt(this.input.max)),
        this.querySelector(".quantity__button[name='plus']").classList.toggle(
          "disabled",
          e <= t,
        )));
  }
}
customElements.define("quantity-input", QuantityInput);
class QuantityInputCart extends QuantityInput {
  constructor() {
    super();
  }
  onButtonClick(e) {
    e.preventDefault();
    var t = this.input.value;
    this.input.min == t && "minus" === e.target.name
      ? ((this.input.value = 0), this.input.dispatchEvent(this.changeEvent))
      : ("plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(),
        t !== this.input.value && this.input.dispatchEvent(this.changeEvent));
  }
}
function debounce(t, i) {
  let s;
  return (...e) => {
    (clearTimeout(s), (s = setTimeout(() => t.apply(this, e), i)));
  };
}
function throttle(i, s) {
  let n = 0;
  return function (...e) {
    var t = new Date().getTime();
    if (!(t - n < s)) return ((n = t), i(...e));
  };
}
function fetchConfig(e = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/" + e },
  };
}
(customElements.define("quantity-input-cart", QuantityInputCart),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var i = 0, s = e.options.length; i < s; i++) {
      var n = e.options[i];
      if (t == n.value || t == n.innerHTML) return (e.selectedIndex = i);
    }
  }),
  (Shopify.addListener = function (e, t, i) {
    e.addEventListener
      ? e.addEventListener(t, i, !1)
      : e.attachEvent("on" + t, i);
  }),
  (Shopify.postLink = function (e, t) {
    var i,
      s = (t = t || {}).method || "post",
      n = t.parameters || {},
      o = document.createElement("form");
    for (i in (o.setAttribute("method", s), o.setAttribute("action", e), n)) {
      var r = document.createElement("input");
      (r.setAttribute("type", "hidden"),
        r.setAttribute("name", i),
        r.setAttribute("value", n[i]),
        o.appendChild(r));
    }
    (document.body.appendChild(o), o.submit(), document.body.removeChild(o));
  }),
  (Shopify.CountryProvinceSelector = function (e, t, i) {
    ((this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(i.hideElement || t)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this),
      ),
      this.initCountry(),
      this.initProvince());
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      (Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler());
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e &&
        0 < this.provinceEl.options.length &&
        Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = (s =
          this.countryEl.options[this.countryEl.selectedIndex]).getAttribute(
          "data-provinces",
        ),
        i = JSON.parse(t);
      if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var s, n = 0; n < i.length; n++)
          (((s = document.createElement("option")).value = i[n][0]),
            (s.innerHTML = i[n][1]),
            this.provinceEl.appendChild(s));
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild; ) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      var i = 0;
      for (t.length; i < t.length; i++) {
        var s = document.createElement("option");
        ((s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s));
      }
    },
  }));
class MenuDrawer extends HTMLElement {
  constructor() {
    (super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents());
  }
  bindEvents() {
    (this.querySelectorAll("summary").forEach((e) =>
      e.addEventListener("click", this.onSummaryClick.bind(this)),
    ),
      this.querySelectorAll(
        "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)",
      ).forEach((e) =>
        e.addEventListener("click", this.onCloseButtonClick.bind(this)),
      ),
      this.querySelectorAll(".close, .button-close").forEach((e) =>
        e.addEventListener("click", (e) => {
          this.closeMenuDrawer();
        }),
      ),
      this.querySelectorAll(".modal__content, .mobile-facets").forEach((e) =>
        e.addEventListener("click", this.shouldClose.bind(this)),
      ));
  }
  shouldClose(e) {
    (e.target.classList.contains("mobile-facets") ||
      e.target.classList.contains("modal__content")) &&
      this.closeMenuDrawer(e, this.mainDetailsToggle.querySelector("summary"));
  }
  onKeyUp(e) {
    var t;
    "ESCAPE" === e.code.toUpperCase() &&
      (t = e.target.closest("details[open]")) &&
      (t === this.mainDetailsToggle
        ? this.closeMenuDrawer(
            e,
            this.mainDetailsToggle.querySelector("summary"),
          )
        : this.closeSubmenu(t));
  }
  onSummaryClick(e) {
    let t = e.currentTarget,
      i = t.parentNode,
      s = i.closest(".has-submenu"),
      n = i.hasAttribute("open"),
      o = window.matchMedia("(prefers-reduced-motion: reduce)");
    function r() {
      (i.querySelector("button")
        ? trapFocus(t.nextElementSibling, i.querySelector("button"))
        : trapFocus(t.nextElementSibling),
        t.nextElementSibling.removeEventListener("transitionend", r));
    }
    i === this.mainDetailsToggle
      ? (n && e.preventDefault(),
        n ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t),
        window.matchMedia("(max-width: 990px)") &&
          document.documentElement.style.setProperty(
            "--viewport-height",
            window.innerHeight + "px",
          ))
      : setTimeout(() => {
          (n
            ? i.classList.remove("menu-opening")
            : i.classList.add("menu-opening"),
            t.setAttribute("aria-expanded", !n),
            s && s.classList.add("submenu-open"),
            !o || o.matches
              ? r()
              : t.nextElementSibling.addEventListener("transitionend", r));
        }, 100);
  }
  openMenuDrawer(e) {
    (setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      e.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, e));
  }
  closeMenuDrawer(e, t = !1) {
    void 0 !== e &&
      (this.mainDetailsToggle.classList.remove("menu-opening"),
      this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
        (e.removeAttribute("open"), e.classList.remove("menu-opening"));
      }),
      this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((e) => {
        e.classList.remove("submenu-open");
      }),
      removeTrapFocus(t),
      this.closeAnimation(this.mainDetailsToggle),
      e instanceof KeyboardEvent) &&
      t?.setAttribute("aria-expanded", !1);
  }
  onFocusOut() {
    setTimeout(() => {
      !this.mainDetailsToggle.hasAttribute("open") ||
        this.mainDetailsToggle.contains(document.activeElement) ||
        (this.hasAttribute("data-trigger") &&
          document.activeElement == document.querySelector("body")) ||
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(e) {
    e = e.currentTarget.closest("details");
    this.closeSubmenu(e);
  }
  closeSubmenu(e) {
    var t = e.closest(".submenu-open");
    (t && t.classList.remove("submenu-open"),
      e.classList.remove("menu-opening"),
      e.querySelector("summary").setAttribute("aria-expanded", !1),
      removeTrapFocus(e.querySelector("summary")),
      this.closeAnimation(e));
  }
  closeAnimation(t) {
    let i,
      s = (e) => {
        e - (i = void 0 === i ? e : i) < 400
          ? window.requestAnimationFrame(s)
          : (t.removeAttribute("open"),
            t.closest("details[open]") &&
              trapFocus(
                t.closest("details[open]"),
                t.querySelector("summary"),
              ));
      };
    window.requestAnimationFrame(s);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  bindEvents() {
    (super.bindEvents(),
      (this.triggerSelector = this.dataset.trigger),
      this.triggerSelector &&
        ((this.triggers = document.querySelectorAll(
          `[href="#${this.triggerSelector}"], .` + this.triggerSelector,
        )),
        this.triggers?.forEach((e) => {
          e.addEventListener("click", this.triggerClick.bind(this));
        })));
    var e = this.querySelector("button.search__button");
    e &&
      e.addEventListener("click", (e) => {
        (e.stopPropagation(),
          this.closeMenuDrawer(
            e,
            this.mainDetailsToggle.querySelector("summary"),
          ),
          setTimeout(() => {
            var e = document.querySelector("details-modal.search-trigger");
            e && e.querySelector("summary")?.click();
          }, 420));
      });
  }
  triggerClick(e) {
    e.preventDefault();
    let t = this.querySelector(":scope > details > summary");
    e = e.currentTarget.closest("header-drawer");
    e
      ? (e.querySelector(":scope > details > summary").click(),
        setTimeout(() => {
          t.click();
        }, 500))
      : t.click();
  }
  openMenuDrawer(e) {
    ((this.header = this.header || document.querySelector(".section-header")),
      this.header.classList.add("menu-open"),
      document.querySelector("body").classList.add("drawer-open"),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }),
      (this.summary = e).setAttribute("aria-expanded", !0),
      window.addEventListener("resize", this.onResize),
      trapFocus(this.mainDetailsToggle, e));
  }
  closeMenuDrawer(e, t) {
    (this.header.classList.remove("menu-open"),
      setTimeout(() => {
        document.querySelector("body").classList.remove("drawer-open");
      }, 400),
      window.removeEventListener("resize", this.onResize),
      (t = t || this.summary),
      super.closeMenuDrawer(!0, t));
  }
  onResize = () => {
    document.documentElement.style.setProperty(
      "--viewport-height",
      window.innerHeight + "px",
    );
  };
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    (super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this, !1),
      ),
      this.addEventListener("keyup", (e) => {
        "ESCAPE" === e.code.toUpperCase() && this.hide();
      }),
      this.classList.contains("media-modal")
        ? this.addEventListener("pointerup", (e) => {
            "mouse" !== e.pointerType ||
              e.target.closest("deferred-media, product-model") ||
              this.hide();
          })
        : this.addEventListener("click", (e) => {
            e.target === this && this.hide();
          }));
  }
  connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this));
  }
  show(e) {
    this.openedBy = e;
    e = this.querySelector(".template-popup");
    (this.setAttribute("open", ""),
      e && e.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia());
  }
  hide() {
    (document.body.dispatchEvent(new CustomEvent("modalClosed")),
      this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia());
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    let t = this.querySelector("button");
    t &&
      t.addEventListener("click", () => {
        var e = document.querySelector(this.getAttribute("data-modal"));
        e && e.show(t);
      });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    var e = this.querySelector('[id^="Deferred-Poster-"]');
    e && e.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(e = !0) {
    var t;
    (window.pauseAllMedia(),
      this.getAttribute("loaded") ||
        ((t = document.createElement("div")).appendChild(
          this.querySelector("template").content.firstElementChild.cloneNode(
            !0,
          ),
        ),
        this.setAttribute("loaded", !0),
        (t = this.appendChild(t.querySelector("video, model-viewer, iframe"))),
        e && t.focus(),
        "VIDEO" == t.nodeName && t.getAttribute("autoplay") && t.play()));
  }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    (super(),
      (this.slider = this.querySelector('[id^="Slider-"]')),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector(
        ".slider-counter--current",
      )),
      (this.pageTotalElement = this.querySelector(".slider-counter--total")),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      this.slider &&
        this.nextButton &&
        (this.initPages(),
        new ResizeObserver((e) => this.initPages()).observe(this.slider),
        this.slider.addEventListener("scroll", this.update.bind(this)),
        this.prevButton.addEventListener(
          "click",
          this.onButtonClick.bind(this),
        ),
        this.nextButton.addEventListener(
          "click",
          this.onButtonClick.bind(this),
        )));
  }
  initPages() {
    ((this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (e) => 0 < e.clientWidth,
    )),
      this.sliderItemsToShow.length < 2 ||
        ((this.sliderItemOffset =
          this.sliderItemsToShow[1].offsetLeft -
          this.sliderItemsToShow[0].offsetLeft),
        (this.slidesPerPage = Math.floor(
          (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
            this.sliderItemOffset,
        )),
        (this.totalPages =
          this.sliderItemsToShow.length - this.slidesPerPage + 1),
        this.update()));
  }
  resetPages() {
    ((this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      this.initPages());
  }
  update() {
    var e;
    this.slider &&
      this.nextButton &&
      ((e = this.currentPage),
      (this.currentPage =
        Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != e &&
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          }),
        ),
      this.enableSliderLooping ||
        (this.isSlideVisible(this.sliderItemsToShow[0]) &&
        0 === this.slider.scrollLeft
          ? this.prevButton.setAttribute("disabled", "disabled")
          : this.prevButton.removeAttribute("disabled"),
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
        )
          ? this.nextButton.setAttribute("disabled", "disabled")
          : this.nextButton.removeAttribute("disabled")));
  }
  isSlideVisible(e, t = 0) {
    t = this.slider.clientWidth + this.slider.scrollLeft - t;
    return (
      e.offsetLeft + e.clientWidth <= t &&
      e.offsetLeft >= this.slider.scrollLeft
    );
  }
  onButtonClick(e) {
    e.preventDefault();
    var t = e.currentTarget.dataset.step || 1;
    ((this.slideScrollPosition =
      "next" === e.currentTarget.name
        ? this.slider.scrollLeft + t * this.sliderItemOffset
        : this.slider.scrollLeft - t * this.sliderItemOffset),
      this.setSlidePosition(this.slideScrollPosition));
  }
  setSlidePosition(e) {
    this.slider.scrollTo({ left: e });
  }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    (super(),
      (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
      (this.enableSliderLooping = !0),
      this.sliderControlWrapper &&
        ((this.sliderFirstItemNode =
          this.slider.querySelector(".slideshow__slide")),
        0 < this.sliderItemsToShow.length && (this.currentPage = 1),
        (this.announcementBarSlider = this.querySelector(
          ".announcement-bar-slider",
        )),
        (this.announcerBarAnimationDelay = this.announcementBarSlider
          ? 250
          : 0),
        (this.sliderControlLinksArray = Array.from(
          this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
        )),
        this.sliderControlLinksArray.forEach((e) =>
          e.addEventListener("click", this.linkToSlide.bind(this)),
        ),
        this.slider.addEventListener(
          "scroll",
          this.setSlideVisibility.bind(this),
        ),
        this.setSlideVisibility(),
        this.announcementBarSlider &&
          ((this.announcementBarArrowButtonWasClicked = !1),
          (this.reducedMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
          )),
          this.reducedMotion.addEventListener("change", () => {
            "true" === this.slider.getAttribute("data-autoplay") &&
              this.setAutoPlay();
          }),
          [this.prevButton, this.nextButton].forEach((e) => {
            e.addEventListener(
              "click",
              () => {
                this.announcementBarArrowButtonWasClicked = !0;
              },
              { once: !0 },
            );
          })),
        "true" === this.slider.getAttribute("data-autoplay")) &&
        this.setAutoPlay());
  }
  setAutoPlay() {
    ((this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
      this.addEventListener("mouseover", this.focusInHandling.bind(this)),
      this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
      this.addEventListener("focusin", this.focusInHandling.bind(this)),
      this.addEventListener("focusout", this.focusOutHandling.bind(this)),
      this.querySelector(".slideshow__autoplay")
        ? ((this.sliderAutoplayButton = this.querySelector(
            ".slideshow__autoplay",
          )),
          this.sliderAutoplayButton.addEventListener(
            "click",
            this.autoPlayToggle.bind(this),
          ),
          (this.autoplayButtonIsSetToPlay = !0),
          this.play())
        : this.reducedMotion.matches ||
            this.announcementBarArrowButtonWasClicked
          ? this.pause()
          : this.play());
  }
  onButtonClick(e) {
    (super.onButtonClick(e), (this.wasClicked = !0));
    var t = 1 === this.currentPage,
      i = this.currentPage === this.sliderItemsToShow.length;
    ((t || i) &&
      (t && "previous" === e.currentTarget.name
        ? (this.slideScrollPosition =
            this.slider.scrollLeft +
            this.sliderFirstItemNode.clientWidth *
              this.sliderItemsToShow.length)
        : i &&
          "next" === e.currentTarget.name &&
          (this.slideScrollPosition = 0),
      this.setSlidePosition(this.slideScrollPosition)),
      this.applyAnimationToAnnouncementBar(e.currentTarget.name));
  }
  setSlidePosition(e) {
    (this.setPositionTimeout && clearTimeout(this.setPositionTimeout),
      (this.setPositionTimeout = setTimeout(() => {
        this.slider.scrollTo({ left: e });
      }, this.announcerBarAnimationDelay)));
  }
  update() {
    (super.update(),
      (this.sliderControlButtons = this.querySelectorAll(
        ".slider-counter__link",
      )),
      this.prevButton.removeAttribute("disabled"),
      this.sliderControlButtons.length &&
        (this.sliderControlButtons.forEach((e) => {
          (e.classList.remove("slider-counter__link--active"),
            e.removeAttribute("aria-current"));
        }),
        this.sliderControlButtons[this.currentPage - 1].classList.add(
          "slider-counter__link--active",
        ),
        this.sliderControlButtons[this.currentPage - 1].setAttribute(
          "aria-current",
          !0,
        )));
  }
  autoPlayToggle() {
    (this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
      (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay));
  }
  focusOutHandling(e) {
    this.sliderAutoplayButton
      ? ((e =
          e.target === this.sliderAutoplayButton ||
          this.sliderAutoplayButton.contains(e.target)),
        this.autoplayButtonIsSetToPlay && !e && this.play())
      : this.reducedMotion.matches ||
        this.announcementBarArrowButtonWasClicked ||
        this.play();
  }
  focusInHandling(e) {
    this.sliderAutoplayButton
      ? (e.target === this.sliderAutoplayButton ||
          this.sliderAutoplayButton.contains(e.target)) &&
        this.autoplayButtonIsSetToPlay
        ? this.play()
        : this.autoplayButtonIsSetToPlay && this.pause()
      : this.announcementBarSlider.contains(e.target) && this.pause();
  }
  play() {
    (this.slider.setAttribute("aria-live", "off"),
      clearInterval(this.autoplay),
      (this.autoplay = setInterval(
        this.autoRotateSlides.bind(this),
        this.autoplaySpeed,
      )));
  }
  pause() {
    (this.slider.setAttribute("aria-live", "polite"),
      clearInterval(this.autoplay));
  }
  togglePlayButtonState(e) {
    e
      ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.playSlideshow,
        ))
      : (this.sliderAutoplayButton.classList.remove(
          "slideshow__autoplay--paused",
        ),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.pauseSlideshow,
        ));
  }
  autoRotateSlides() {
    var e =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;
    (this.setSlidePosition(e), this.applyAnimationToAnnouncementBar());
  }
  setSlideVisibility(e) {
    (this.sliderItemsToShow.forEach((e, t) => {
      var i = e.querySelectorAll("a");
      t === this.currentPage - 1
        ? (i.length &&
            i.forEach((e) => {
              e.removeAttribute("tabindex");
            }),
          e.setAttribute("aria-hidden", "false"),
          e.removeAttribute("tabindex"))
        : (i.length &&
            i.forEach((e) => {
              e.setAttribute("tabindex", "-1");
            }),
          e.setAttribute("aria-hidden", "true"),
          e.setAttribute("tabindex", "-1"));
    }),
      (this.wasClicked = !1));
  }
  applyAnimationToAnnouncementBar(o = "next") {
    if (this.announcementBarSlider) {
      var r = this.sliderItems.length,
        a = this.currentPage - 1,
        l = (a + ("next" === o ? 1 : -1)) % r;
      let e = this.sliderItems[-1 == l ? r - 1 : l],
        t = this.sliderItems[a],
        i = "announcement-bar-slider--fade-in",
        s = "announcement-bar-slider--fade-out",
        n =
          ("next" === o && !(a == r - 1)) || ("previous" === o && 0 == a)
            ? "next"
            : "previous";
      (t.classList.add(s + "-" + n),
        e.classList.add(i + "-" + n),
        setTimeout(() => {
          (t.classList.remove(s + "-" + n), e.classList.remove(i + "-" + n));
        }, 2 * this.announcerBarAnimationDelay));
    }
  }
  linkToSlide(e) {
    e.preventDefault();
    e =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(e.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({ left: e });
  }
}
customElements.define("slideshow-component", SlideshowComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("change", (e) => {
      var t = this.getInputForEventTarget(e.target);
      (this.updateSelectionMetadata(e),
        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event: e,
            target: t,
            selectedOptionValues: this.selectedOptionValues,
          },
        }));
    });
  }
  updateSelectionMetadata({ target: e }) {
    var t,
      i,
      { value: s, tagName: n } = e;
    "SELECT" === n && e.selectedOptions.length
      ? (Array.from(e.options)
          .find((e) => e.getAttribute("selected"))
          .removeAttribute("selected"),
        e.selectedOptions[0].setAttribute("selected", "selected"),
        (i = e.selectedOptions[0].dataset.optionSwatchValue),
        (t = e
          .closest(".product-form__input")
          .querySelector("[data-selected-value] > .swatch")) &&
          (i
            ? (t.style.setProperty("--swatch--background", i),
              t.classList.remove("swatch--unavailable"))
            : (t.style.setProperty("--swatch--background", "unset"),
              t.classList.add("swatch--unavailable")),
          t.style.setProperty(
            "--swatch-focal-point",
            e.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset",
          )))
      : "INPUT" === n &&
        "radio" === e.type &&
        (i = e
          .closest(".product-form__input")
          .querySelector("[data-selected-value]")) &&
        (i.innerHTML = s);
  }
  getInputForEventTarget(e) {
    return "SELECT" === e.tagName ? e.selectedOptions[0] : e;
  }
  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked"),
    ).map(({ dataset: e }) => e.optionValueId);
  }
}
customElements.define("variant-selects", VariantSelects);
class FavMarquee extends HTMLElement {
  constructor() {
    (super(),
      (this.items = this.querySelectorAll(".item")),
      (this.wrapper = this.querySelector(".wrapper")),
      0 != this.items.length &&
        document.addEventListener(
          "DOMContentLoaded",
          this.initialize.bind(this),
        ));
  }
  initialize() {
    ((this.width = 0),
      this.items.forEach((e) => {
        this.width += e.offsetWidth;
      }));
    var t = this.dataset.itemMultiplicator;
    for (let e = 0; e < t; e++)
      this.items.forEach((e) => {
        e = e.cloneNode(!0);
        this.wrapper.appendChild(e);
      });
    (this.wrapper.style.setProperty(
      "--animation-width",
      "-" + this.width + "px",
    ),
      (this.factor = this.width / 300),
      (this.speed = this.dataset.speed * this.factor),
      (this.wrapper.style.animationDuration = this.speed + "s"),
      this.classList.add("active"));
  }
  toggleResetButton() {
    var e = this.resetButton.classList.contains("hidden");
    0 < this.input.value.length && e
      ? this.resetButton.classList.remove("hidden")
      : 0 !== this.input.value.length ||
        e ||
        this.resetButton.classList.add("hidden");
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset(e) {
    (e.preventDefault(),
      this.shouldResetForm() &&
        ((this.input.value = ""),
        this.input.focus(),
        this.toggleResetButton()));
  }
}
customElements.define("fav-marquee", FavMarquee);
class ContentItem extends HTMLElement {
  constructor() {
    (super(),
      "true" == this.dataset.inverted &&
        window.innerWidth < 769 &&
        (this.style.order =
          "-" +
          Array.prototype.indexOf.call(this.parentElement.children, this)));
  }
}
customElements.define("content-item", ContentItem);
class DuskPicture extends HTMLElement {
  constructor() {
    (super(),
      (this.img = this.querySelector("img")),
      (this.lazyLoading = !0),
      (this.offscreen = !1),
      (this.rendered = !1),
      new ResizeObserver((e) => this.loadContent()).observe(this.img));
  }
  connectedCallback() {
    (this.loadContent(),
      this.addEventListener("reload-picture", this.reload.bind(this)));
  }
  reload(e) {
    e.detail &&
      (e.detail.image && (this.dataset.image = e.detail.image),
      e.detail.imageMobile && (this.dataset.imageMobile = e.detail.imageMobile),
      (this.rendered = !1),
      this.loadContent());
  }
  loadContent() {
    var e, t, i, s, n, o, r, a;
    (this.rendered && this.clientWidth == this.renderedWidth) ||
      ((e = this.clientWidth),
      (t = this.clientHeight),
      0 == e || 0 == t
        ? (this.offscreen = !0)
        : ((this.rendered = !0),
          (this.renderedWidth = e),
          this.offscreen ||
            ((i = window.innerHeight),
            this.getBoundingClientRect().y < i && (this.lazyLoading = !1)),
          (i = window
            .getComputedStyle(this.parentElement)
            .getPropertyValue("--proportion-m")),
          (s = window
            .getComputedStyle(this.parentElement)
            .getPropertyValue("--proportion-d")),
          "size" == (window.innerWidth <= 768 ? i : s) &&
            (window.innerWidth <= 768 && void 0 !== this.dataset.imageMobile
              ? this.dataset.imageProportionMobile
              : this.dataset.imageProportion,
            (this.style.aspectRatio = this.dataset.imageProportion)),
          (i =
            e <= 768 && void 0 !== this.dataset.imageMobile
              ? this.dataset.imageMobile
              : this.dataset.image),
          (s = 2 * e),
          (n = 3 * e),
          (o = 2 * t),
          (r = 3 * t),
          document.createElement("source"),
          this.lazyLoading
            ? (this.img.setAttribute("loading", "lazy"),
              this.img.setAttribute("fetchpriority", "low"))
            : ((a = document.createElement("link")).setAttribute(
                "rel",
                "preload",
              ),
              a.setAttribute("as", "image"),
              a.setAttribute("src", i + `&width=${e}&height=${t}&crop=center`),
              a.setAttribute(
                "imagesrcset",
                i +
                  `&width=${s}&height=${o}&crop=center 2x, ${i}&width=${n}&height=${r}&crop=center 3x`,
              ),
              document.querySelector("head").appendChild(a),
              this.img.setAttribute("fetchpriority", "high")),
          this.img.setAttribute("width", e),
          this.img.setAttribute("height", t),
          this.img.setAttribute(
            "srcset",
            i +
              `&width=${e}&height=${t}&crop=center 1x, ${i}&width=${s}&height=${o}&crop=center 2x, ${i}&width=${n}&height=${r}&crop=center 3x`,
          )));
  }
}
customElements.define("dusk-picture", DuskPicture);
class DuskTabs extends HTMLElement {
  constructor() {
    (super(),
      (this.tabs = this.querySelectorAll(":scope > .tab")),
      this.tabs?.forEach((e, t) => {
        (e.style.setProperty("--tab-index", t),
          e.addEventListener("click", this.onClick.bind(this)));
      }),
      (this.contents = this.querySelectorAll(":scope > .content")),
      this.contents?.forEach((e, t) => {
        e.style.setProperty("--content-index", t);
      }),
      (this.icons = []),
      this.tabs?.forEach((e, t) => {
        var i = document.createElement("span");
        (i.classList.add("icon"),
          i.style.setProperty("--icon-index", t),
          e.classList.contains("active") && i.classList.add("active"),
          i.addEventListener("click", () => this.onClick({ target: e })),
          e.after(i),
          this.icons.push(i),
          0 <= t &&
            ((i = document.createElement("hr")).classList.add("row-divider"),
            i.style.setProperty("--divider-index", t),
            e.before(i)));
      }),
      this.initialize(),
      window.addEventListener("resize", this.initialize.bind(this)));
  }
  initialize() {
    var e =
      window.innerWidth < 769
        ? this.dataset.typeMobile
        : this.dataset.typeDesktop;
    if ((this.setAttribute("type", e), "tabs" == e)) {
      let i = !1;
      (this.tabs.forEach((e, t) => {
        0 == i && e.classList.contains("active")
          ? (i = !0)
          : i &&
            e.classList.contains("active") &&
            (e.classList.remove("active"),
            this.contents[t].classList.remove("active"));
      }),
        !1 === i &&
          (this.tabs[0]?.classList.add("active"),
          this.contents[0]?.classList.add("active")));
    }
  }
  onClick(e) {
    let i = e.target;
    var e = i.style.getPropertyValue("--tab-index"),
      t = this.contents[e];
    "accordion" == this.getAttribute("type")
      ? i.classList.contains("active")
        ? (i.classList.remove("active"),
          t.classList.remove("active"),
          this.icons[e]?.classList.remove("active"))
        : (i.classList.add("active"),
          t.classList.add("active"),
          this.icons[e]?.classList.add("active"),
          this.initChildren(t))
      : "tabs" == this.getAttribute("type")
        ? i.classList.contains("active") ||
          (i.classList.add("active"),
          t.classList.add("active"),
          this.tabs.forEach((e) => {
            var t;
            e != i &&
              ((t = e.style.getPropertyValue("--tab-index")),
              (t = this.contents[t]),
              e.classList.remove("active"),
              t.classList.remove("active"));
          }),
          this.initChildren(t))
        : "select" == this.getAttribute("type") &&
          (this.classList.toggle("open"),
          i.classList.contains("active") ||
            (i.classList.add("active"),
            t.classList.add("active"),
            this.tabs.forEach((e) => {
              var t;
              e != i &&
                ((t = e.style.getPropertyValue("--tab-index")),
                (t = this.contents[t]),
                e.classList.remove("active"),
                t.classList.remove("active"));
            }),
            this.initChildren(t)));
  }
  initChildren(e) {
    e.querySelectorAll("swiper-container")?.forEach((e) => {
      e.swiper.update();
    });
  }
}
customElements.define("dusk-tabs", DuskTabs);
class CardProduct extends HTMLElement {
  constructor() {
    (super(),
      (this.links = this.querySelectorAll("a")),
      (this.swatches = this.querySelectorAll("dusk-swatch")),
      (this.idInput = this.querySelector('input[name="id"]')),
      (this.duskPicture = this.querySelector("dusk-picture.primary")),
      (this.duskPictureSecondary = this.querySelector(
        "dusk-picture.secondary",
      )));
  }
  connectedCallback() {
    this.swatches?.forEach((e) => {
      e.addEventListener("click", this.swatchClick.bind(this));
    });
  }
  disconnectedCallback() {}
  swatchClick(e) {
    let t = e.target;
    if (
      (t.classList.add("active"),
      this.swatches.forEach((e) => {
        e != t && e.classList.remove("active");
      }),
      void 0 !== t.dataset.variantUrl &&
        this.links.forEach((e) => {
          e.setAttribute("href", t.dataset.variantUrl);
        }),
      void 0 !== t.dataset.variantId &&
        this.idInput?.setAttribute("value", t.dataset.variantId),
      void 0 !== t.dataset.image)
    ) {
      let e = new CustomEvent("reload-picture", {
        detail: { image: t.dataset.image },
      });
      this.duskPicture?.dispatchEvent(e);
    }
    if (void 0 !== t.dataset.imageHover) {
      let e = new CustomEvent("reload-picture", {
        detail: { image: t.dataset.imageHover },
      });
      this.duskPictureSecondary?.dispatchEvent(e);
    }
  }
}
customElements.define("card-product", CardProduct);
class DuskVideo extends HTMLElement {
  constructor() {
    (super(), (this.video = this.querySelector("video")), this.init());
  }
  connectedCallback() {
    this._setupLazyLoad();
  }
  _setupLazyLoad() {
    let i = this.video.querySelectorAll("source[data-src]");
    if (i.length) {
      let t = new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            e.isIntersecting &&
              (i.forEach((e) => {
                ((e.src = e.dataset.src), e.removeAttribute("data-src"));
              }),
              this.video.load(),
              this.video.hasAttribute("autoplay") &&
                this.video.play().catch(() => {}),
              t.disconnect());
          });
        },
        { rootMargin: "200px" },
      );
      t.observe(this);
    }
  }
  init() {
    (this.addEventListener("click", (e) => {
      e.target.closest(".dusk-video__control-buttons") || this.togglePlay();
    }),
      ("mute" != this.getAttribute("on-click") &&
        "unmute" != this.getAttribute("on-click")) ||
        this.addEventListener("click", this.onClickMute.bind(this)));
    var e = this.querySelector(".dusk-video__sound-btn");
    (e &&
      e.addEventListener("click", (e) => {
        (e.stopPropagation(), this.toggleSound());
      }),
      (this.playBtn = this.querySelector(".dusk-video__play-btn")),
      this.playBtn &&
        this.playBtn.addEventListener("click", (e) => {
          (e.stopPropagation(), this.togglePlay());
        }),
      (this.overlay = this.querySelector(".dusk-video__play-overlay")),
      this.video.addEventListener("play", () => this.updatePlayState()),
      this.video.addEventListener("pause", () => this.updatePlayState()),
      this.updatePlayState());
  }
  updatePlayState() {
    (this.playBtn?.classList.toggle("is-playing", !this.video.paused),
      this.updateOverlay());
  }
  updateOverlay() {
    this.overlay &&
      (this._overlayTimeout && clearTimeout(this._overlayTimeout),
      this.overlay.classList.toggle("is-playing", !this.video.paused),
      this.overlay.classList.add("is-visible"),
      (this._overlayTimeout = setTimeout(() => {
        this.overlay.classList.remove("is-visible");
      }, 800)));
  }
  onClickPlay() {
    if (this.video.paused) {
      let t = this.video;
      (document.querySelectorAll("dusk-video video")?.forEach((e) => {
        e == t || e.paused || e.pause();
      }),
        this.video.play());
    } else this.video.pause();
  }
  onClickMute() {
    if (this.video.muted) {
      let t = this.video;
      (document.querySelectorAll("video")?.forEach((e) => {
        e == t ||
          e.paused ||
          ((this.video.muted = !0), this.video.classList.add("muted"));
      }),
        (this.video.muted = !1),
        this.video.classList.remove("muted"));
    } else ((this.video.muted = !0), this.video.classList.add("muted"));
  }
  togglePlay() {
    this.video.paused
      ? this.video.play().catch(() => this.updatePlayState())
      : this.video.pause();
  }
  toggleSound() {
    var e = this.querySelector(".dusk-video__sound-btn");
    ((this.video.muted = !this.video.muted),
      this.video.classList.toggle("muted", this.video.muted),
      e.classList.toggle("is-muted", this.video.muted));
  }
}
customElements.define("dusk-video", DuskVideo);
(function () {
  var S =
      "<svg viewBox='0 0 24 24' width='18' height='18' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M4 9h4l5-4v14l-5-4H4z'/><path d='M16.5 9.5a3.5 3.5 0 0 1 0 5'/><path d='M19 7a7 7 0 0 1 0 10'/>",
    ON = S + "</svg>",
    OFF = S + "<path d='M3 3l18 18'/></svg>";
  function i() {
    document.querySelectorAll(".product-gallery-video").forEach(function (v) {
      var p = v.parentElement;
      if (!p || p.querySelector(".fav-sound-btn")) return;
      var b = document.createElement("button");
      b.type = "button";
      b.className = "fav-sound-btn";
      p.appendChild(b);
      function u() {
        b.innerHTML = v.muted ? OFF : ON;
        b.setAttribute(
          "aria-label",
          v.muted ? "Turn sound on" : "Turn sound off",
        );
        b.classList.toggle("is-muted", v.muted);
      }
      b.addEventListener("click", function (e) {
        e.stopPropagation();
        v.muted = !v.muted;
        if (!v.muted) {
          v.classList.add("active");
          v.play();
        }
        u();
      });
      v.addEventListener("volumechange", u);
      u();
    });
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", i)
    : i();
})();
/* FAV fix: sliders configured with the generic ".swiper-button-next/prev"
   selectors (empty navigation-id) were taking over every arrow on the page,
   including the product gallery's. Rebind them to their own arrows only. */
(function () {
  var tries = 0;
  function fixNav() {
    var pending = false;
    document
      .querySelectorAll('swiper-container[navigation-next-el=".swiper-button-next"]')
      .forEach(function (s) {
        if (s.dataset.favNavFixed) return;
        var w = s.swiper;
        if (!w || !w.navigation) {
          pending = true;
          return;
        }
        var box = s.parentElement;
        var next = box.querySelector(":scope > .swiper-button-next");
        var prev = box.querySelector(":scope > .swiper-button-prev");
        w.navigation.destroy();
        w.params.navigation.nextEl = next || null;
        w.params.navigation.prevEl = prev || null;
        if (next || prev) {
          w.navigation.init();
          w.navigation.update();
        }
        s.dataset.favNavFixed = "1";
      });
    // Refresh the arrows of the other sliders (e.g. the product gallery)
    document.querySelectorAll("swiper-container").forEach(function (s) {
      var w = s.swiper;
      if (s.dataset.favNavFixed || !w || !w.navigation || !w.params.navigation || !w.params.navigation.nextEl) return;
      w.navigation.update();
    });
    if (pending && tries++ < 25) setTimeout(fixNav, 200);
  }
  if (document.readyState === "complete") fixNav();
  else window.addEventListener("load", fixNav);
})();